function initAnnouncementSlider() {
  var announcementSlider = new Swiper('.cstm-announcement', {
      loop: true,
      grabCursor: true,
      init: true,
      slidesPerView: 1
});
}


function isElementMovedUpAndOutOfViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.bottom <= 0 &&
        rect.top < window.innerHeight
    );
}

function checkVisibility() {
    let ogPaymentElement = document.querySelector(".og-payment");
    let stickyatc = document.querySelector("#cstm-sticky-bar");
    if (isElementMovedUpAndOutOfViewport(ogPaymentElement)) {
        stickyatc.classList.add("mvisible");
    } else {
        stickyatc.classList.remove("mvisible");
    }
}  
  window.addEventListener("scroll", checkVisibility);
  window.addEventListener("resize", checkVisibility); // Listen for window resize
  checkVisibility();

function updatePriceNimageSticky()
{
  var getData = document.querySelector('div#cstm-sticky-bar select.select__select').selectedOptions[0].dataset;
  var image = getData.image;
  var price = getData.price;
  var cprice = getData.cprice;
  
if(document.querySelector('div#cstm-sticky-bar img.sticky-bar-thumb-thumb'))
document.querySelector('div#cstm-sticky-bar img.sticky-bar-thumb-thumb').src= image;
  
if(document.querySelector('div#cstm-sticky-bar span.price-item.price-item--sale'))
document.querySelector('div#cstm-sticky-bar span.price-item.price-item--sale').innerHTML= price;
 
if(document.querySelector('div#cstm-sticky-bar s.price-item.price-item--regular'))
document.querySelector('div#cstm-sticky-bar s.price-item.price-item--regular').innerHTML= cprice;
}